import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles } from 'lucide-react';
export function Results() {
  return <section className="py-24 bg-palomitas-coral text-white text-center relative overflow-hidden" data-id="element-123">
      <div className="absolute inset-0 overflow-hidden z-0" data-id="element-124">
        <div className="absolute top-[-20%] left-[-10%] w-96 h-96 bg-palomitas-pink/30 rounded-full blur-3xl" data-id="element-125"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-96 h-96 bg-palomitas-orange/30 rounded-full blur-3xl" data-id="element-126"></div>
      </div>

      <div className="container px-4 mx-auto max-w-3xl relative z-10" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-128">
          <Sparkles className="mx-auto mb-6 text-white/80" size={40} data-id="element-129" />
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-130">
            Ellos son nuestros alumnos: querían ganar más sin salir de su casa
            como vos.
          </h2>
          <div className="flex items-center justify-center gap-3 text-2xl md:text-3xl font-medium text-white/90" data-id="element-131">
            <span data-id="element-132">Hoy transformaron su olla en un ingreso FIJO</span>
            <Heart className="text-white fill-current" size={32} data-id="element-133" />
          </div>
        </motion.div>
      </div>
    </section>;
}